import React from 'react'
import ListPage from 'components/cases/listpage/ListPage'

export const categoryTitle = '内製化支援'
export const baseUrl = '/cases/inhouse-support/'

const InhouseSupport: React.FC = () => {
  return <ListPage categoryTitle={categoryTitle} baseUrl={baseUrl} pageId={1} />
}

export default InhouseSupport
